import { render, staticRenderFns } from "./Recursos.vue?vue&type=template&id=fe0e5f20&scoped=true&"
import script from "./Recursos.vue?vue&type=script&lang=js&"
export * from "./Recursos.vue?vue&type=script&lang=js&"
import style0 from "./Recursos.vue?vue&type=style&index=0&id=fe0e5f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0e5f20",
  null
  
)

export default component.exports